module.exports = __webpack_public_path__ + "img/tenants-icon.ab95625c.svg";